import { render } from "./TempAnnouncement.vue?vue&type=template&id=a2bf590c"
import script from "./TempAnnouncement.vue?vue&type=script&lang=js"
export * from "./TempAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__